import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { getBetaAccess } from '../../api/betaApi';
import { useAuth } from './AuthContext';

interface BetaContextType {
  isBeta: boolean;
  isLoading: boolean;
}

const BetaContext = createContext<BetaContextType>({ isBeta: false, isLoading: true });

export const BetaProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading: authLoading } = useAuth();
  const [isBeta, setIsBeta] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!isAuthenticated) {
      setIsBeta(false);
      setIsLoading(false);
      return;
    }
    getBetaAccess()
      .then(setIsBeta)
      .catch(() => setIsBeta(false))
      .finally(() => setIsLoading(false));
  }, [isAuthenticated, authLoading]);

  return (
    <BetaContext.Provider value={{ isBeta, isLoading }}>
      {children}
    </BetaContext.Provider>
  );
};

export const useBeta = () => useContext(BetaContext);
